export enum DesignEnum {
  Square = 'Square',

  Square45 = 'Square45',

  RotaryFlatHead = 'RotaryFlatHead',

  RotaryWedgeGroove = 'RotaryWedgeGroove',

  GlobeValve = 'GlobeValve',
}
